import React, { useState, useLayoutEffect, useRef, useEffect } from 'react'
import SignIn from "./signIn";
import Register from "./register";
import login from "../../img/login.png";
import loginTitle from "../../img/loginTitile.png";
import { useNavigate } from "react-router-dom";
import "./index.scss";

const Login = () => {

	const navigate = useNavigate();

	// 忘记密码
	const [wangJi, setWangJi] = useState(false)
	// 登录注册
	const [isLogin,setIslogin] = useState(true)
	useEffect(()=>{
		var urlParams = new URLSearchParams(window.location.search);
		var param1 = urlParams.get('a');
		if(param1=='register'){
			setIslogin(true)
		}else{
			setIslogin(false)
		}
	},[])

	const resizeListener = () => {
        // 定义设计图的尺寸 3840
        let designSize = 1920;
        // 获取 html 元素
        let html = document.documentElement;
        // 定义窗口的宽度
        let clientW = html.clientWidth;
        let clienH = html.clientHight;
        // html 的fontsize 大小
        let htmlRem = (clientW * 16) / designSize;
        html.style.fontSize = htmlRem + 'px';
    }

    useEffect(() => {
        window.addEventListener('resize', resizeListener);
        resizeListener();
    }, [])

	return (
			<div className="login-container" style={{ backgroundImage: `url(${login})` }}>
				<img onClick={()=>navigate('/')} src={loginTitle} alt="" />
				<div className="logins">
					<div className="Tabs">
						{
							isLogin?<Register setWangJi={setWangJi} wangJi={wangJi} setIslogin={setIslogin}></Register>:<SignIn setIslogin={setIslogin}></SignIn>
						}
					</div>
				</div>
			</div>
	);
};

export default Login;


